import React from 'react';
import { Form, FormGroup, FormControl, ControlLabel, HelpBlock, Modal, Button } from 'rsuite';
class LoginModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formValue: {
                name: '',
                email: '',
                password: '',
                textarea: ''
            },
            show: false
        };
        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    close() {
        this.setState({ show: false });
    }
    open() {
        this.setState({ show: true });
    }
    handleChange(value) {
        this.setState({
            formValue: value
        });
    }
    render() {
        return (
            <div>
                <Modal show={this.state.show} onHide={this.close} size="xs">
                    <Modal.Header>
                        <Modal.Title>注册</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form
                            fluid
                            onChange={this.handleChange}
                            formValue={this.state.formValue}
                        >
                            <FormGroup>
                                <ControlLabel>账号</ControlLabel>
                                <FormControl name="SchoolNum" />
                                <HelpBlock>必须，用作登录账号</HelpBlock>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>姓名</ControlLabel>
                                <FormControl name="UserName" />
                                <HelpBlock>必须</HelpBlock>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>登录密码</ControlLabel>
                                <FormControl name="Password" type="password" />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>确认密码</ControlLabel>
                                <FormControl name="ConfirmPassword" type="password" />
                            </FormGroup>
                            
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.close} appearance="primary">
                            确认
                        </Button>
                        <Button onClick={this.close} appearance="subtle">
                            取消
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Button onClick={this.open} style={this.props.buttonstyle}>注册</Button>
            </div>
        );
    }
}

export default LoginModal;